<agpr-dialog-container
    [id]="id"
    [showClose]="true"
    [heading]="header"
    (close)="closeDialog(null)"
    [ngClass]="{'agpr-distPicker-dialog-addMode': addMode, 'agpr-distPicker-dialog-selectMode': !addMode }"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>
    <div class="agpr-distPicker">
        <div class="agpr-distPicker-lhp">
            <div class="agpr-distPicker-filter">
                <agpr-autocomplete
                    [ngClass]="{'agpr-distPicker-filter-input': !addMode}"
                    #autocomplete
                    [id]="id + '.filterTextInput'"
                    (clear)="resetDists()"
                    labelField="name"
                    ariaLabel="Discover.distributionBuilder.dialog.filterPlaceholder"
                    (searchStringChanged)="filterRows($event)"
                    [clearOnBlur]="false"
                    placeholder="Discover.distributionBuilder.dialog.filterPlaceholder"
                >
                </agpr-autocomplete>
            </div>
            <span *ngIf="!addMode" class="agpr-distPicker-selectChipContainer">
                <agpr-chip-container
                    [id]="id + '.selectDistributionSummary'"
                    [chips]="workingDistsChips"
                    (removeChip)="removeChip($event)"
                >
                </agpr-chip-container>
            </span>
            <agpr-scroll-panel class="agpr-distPicker-scrollpanel">
                <agpr-table
                    id="distPickerTable"
                    class="agpr-distPicker-table"
                    [columns]="columnDefs"
                    [sortColumn]="nameColumn"
                    [showDelete]="false"
                    [sortAscending]="true"
                    [(ngModel)]="filteredRows"
                    (itemChanged)="selectionChanged($event)"
                    (allSelectedChanged)="selectAllChanged($event)"
                    [vsItemSize]="37"
                    [vsMinBufferPx]="500"
                    [vsMaxBufferPx]="500"
                >
                </agpr-table>
            </agpr-scroll-panel>
        </div>
        <div *ngIf="addMode" class="agpr-distPicker-rhp">
            <agpr-message
                [severity]="messageSeverityEnum.info"
                [id]="id + '.selectedBanner'"
            >
                <span
                    class="agpr-distPicker-bold"
                >
                    {{ selectedCount }}
                </span>
                {{ 'Discover.distributionBuilder.dialog.selectedBanner' | localize }}
            </agpr-message>

            <agpr-panel
                class="agpr-distPicker-panel"
                [contentPadding]="false"
                [toggleable]="false"
            >
            </agpr-panel>
            <agpr-scroll-panel class="agpr-distPicker-distributionSummary">
                <agpr-chip-container
                    class="agpr-distPicker-chipContainer"
                    [id]="id + '.distributionSummary'"
                    [chips]="workingDistsChips"
                    [plainMode]="true"
                    (removeChip)="removeChip($event)"
                ></agpr-chip-container>
                <agpr-message
                    *ngIf="workingDistsChips.length === 0"
                    class="agpr-distPicker-distributionSummary-noContent"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'Discover.distributionBuilder.dialog.distributionSummary.noContent' | localize }}
                </agpr-message>
                <div
                    *ngIf="addMode && workingDistsChips.length > 0"
                    class="agpr-distPicker-selectCheckbox"
                >
                    <agpr-checkbox
                        id="distPicker_addDistributionToBuilder"
                        label="Discover.distributionBuilder.dialog.selectDistributionsCheckbox"
                        [binary]="true"
                        [(ngModel)]="addToDistBuilder"
                        infoCircleTooltip="Discover.distributionBuilder.dialog.addToDistributionBuilderMessage"
                    ></agpr-checkbox>
                </div>
            </agpr-scroll-panel>
        </div>
    </div>


    <ng-template #footerLeft>
        <agpr-button
            [label]="'cancel' | localize"
            (click)="closeDialog(null)"
        >
        </agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            *ngIf="addMode"
            [style]="buttonTypes.primary"
            label="Discover.distributionBuilder.dialog.button.updateButton"
            [disabled]="workingDistsChips.length === 0"
            (click)="updateDistributions()"
        >
        </agpr-button>
        <agpr-button
            *ngIf="!addMode"
            [style]="buttonTypes.primary"
            label="Discover.distributionBuilder.dialog.button.selectButton"
            (click)="selectDistributions()"
        >
        </agpr-button>
    </ng-template>
</agpr-dialog-container>

<ng-template let-row="row" let-column="column" #countInfoCell>
    <div class="agpr-distPicker-table-row">
        <label
            *ngIf="row.count !== null && !row.countLoading"
            class="agpr-distPicker-table-label"
        >
            {{row.count}}
        </label>
        <span>
            <span
                *ngIf="row.modifiedUser"
                role="img"
                class="fa-regular fa-circle-info agpr-distPicker-infoCircle"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser,
                    modifiedDate: row.modifiedDate,
                    modifiedBy: row.modifiedUser
                }"
                [initiallyFocusable]="false"
            ></span>
            <span
                *ngIf="!row.modifiedUser"
                role="img"
                class="fa-regular fa-circle-info agpr-distPicker-infoCircle"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation.unmodified' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser
                }"
                [initiallyFocusable]="false"
            ></span>
        </span>
    </div>
</ng-template>
